import { Component, OnInit, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
	selector: 'app-point',
	templateUrl: './point.component.html',
	styleUrls: ['./point.component.css']
})
export class PointComponent implements OnInit {
	pointForm: any;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	searchStr: any = '';
	modalTitle: any;
	categoryList: any;
	countryList: any;
	pointList: any;
	optionSelected: any;
	isPointAvailable: boolean = true;
	btnTitle: any;
	selectedCategoryId: any;
	selectedPointId: any
	isActivatedAdd: boolean = false;
	isActivatedEdit: boolean = false;
	isActivatedDelete: boolean = false;
	profession: any;
	surveyCategoryList: any;
	category_id: any;
	src:String = "";
	viewType:string = "";
	currentPoint: any;
	config = {
		width: "400px", //width of slides defaults to 800px
		height: "400px", //height of slides defaults to 300px
		autoPlay: true, //autoplay required or not defaults to false
		delay: 3000, // delay for autoplay
	}
	@ViewChild('videoPlayer') videoplayer: ElementRef;

	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService,
		private pagerService: PagerService) { }


	ngOnInit() {
		$(".navbar-brand").text("User Point");
		this.pointForm = new FormGroup({
			
		});

		this.pageNo = 1;
		this.limit = 10;
		this.getPointList(this.pageNo, this.limit, this.searchStr);

	}

	// Get point List
	getPointList = function (pageNo, limit, SeachStr) {
		this.commonService.process();
		this.authService.getUserPointDataList(pageNo, limit, SeachStr).subscribe(data => {
			if (data.success) {
				this.isPointAvailable = true;
				this.pointList = data.point;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}
			else {
				this.isPointAvailable = false;
				this.pointList = [];
			}
			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		//this.pageNo = page;
		this.pager = this.pagerService.getPager(this.total, page);

		// get current page of items
		this.pagedItems = this.pointList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getPointList(page, this.limit, this.searchStr);
		}
	}

	// Delete Selected Point
	deleteSelectedPoint = function (point) {
		this.isActivatedAdd = false;
		this.isActivatedEdit = false;
		this.isActivatedDelete = true;
		this.modalTitle = "Delete Point";
		this.btnTitle = "Yes";
		this.selectedPointId = point._id;
		this.point = point;
	}

	// manage Point
	managePoint = function (pointForm,) {
		if (this.pointForm.valid && this.isActivatedAdd) {
			
		}
		else if (this.pointForm.valid && this.isActivatedEdit) {

		}
		else if (this.isActivatedDelete) {

			pointForm._id = this.selectedPointId;
			this.btnTitle = "Deleting...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.managePoint(pointForm, "delete", this.selectedPointId).subscribe(data => {
                console.log("delete point",data)
				if (data.success) {

					this.getPointList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else {
			this.validationService.validateAllFormFields(this.pointForm);
		}
	}


	// Search Point
	searchPoint = function () {
		this.searchStr = jQuery("#search").val();
		this.getPointList(1, this.limit, this.searchStr);
	}
	
	toggleVideo(event: any) {
		this.videoplayer.nativeElement.play();
	}

	playVideo(data,type){
		if(type=='video'){
			this.viewType = "video";
			this.src = data.videoData ? data.videoData : '';
			this.currentPoint=data;
		}else{
			this.viewType = "image";
			this.src = data.imagesData ? data.imagesData : '../../../assets/img/image-not-found.jpg';
			this.currentPoint=data;
		}
	}

	imageSlider(data){
		var imageArr = [];

		data.forEach((element,index) => {
			imageArr.push({
				image: element,
				title: '' 
			});
		});

		return imageArr
	}
}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/point/point.component.ts